export var ClientRatingSummaryMapper = function (data) {
    var clientRatings = [];
    var tiers = Array.from(new Set(data.map(function (item) { return item.clientTier; })));
    tiers.map(function (tier, i) {
        var TierRecord = {
            clientTier: tier,
            toatalAUA: 0,
            totalCustomerCount: 0,
            finalHighEngaged: "",
            totalAvgProductDepth: 0,
            totalAvgRating: 0,
            clientList: [],
        };
        clientRatings.push(TierRecord);
    });
    clientRatings = clientRatings.map(function (clientRecords) {
        var clientList = data
            .filter(function (item) { return item.clientTier === clientRecords.clientTier; })
            .map(function (record) {
            clientRecords.toatalAUA += record.aua;
            clientRecords.totalCustomerCount += record.customerCnt;
            clientRecords.totalAvgProductDepth += record.productDepth;
            clientRecords.totalAvgRating += record.rating;
            return record;
        });
        clientRecords.clientList = clientList;
        clientRecords.totalAvgProductDepth =
            clientRecords.totalAvgProductDepth / clientList.length;
        clientRecords.totalAvgRating =
            clientRecords.totalAvgRating / clientList.length;
        console.log("clientList.length", clientList);
        return clientRecords;
    });
    return clientRatings;
};
